import type { AuthUser, MembershipRole } from '@starter/shared';

export function tenantRole(user: AuthUser): MembershipRole | null {
  return user.authKind === 'tenant' ? user.role : null;
}

export function homePathForAuthUser(user: AuthUser): string {
  if (user.authKind === 'platform') return '/platform';
  if (user.authKind === 'tenant') {
    switch (user.role) {
      case 'STUDENT':
        return '/student';
      case 'INSTRUCTOR':
        return '/instructor';
      case 'PROGRAM_DIRECTOR':
        return '/pd';
    }
  }
  return '/no-access';
}

export function isPlatformAdminUser(user: AuthUser): boolean {
  return user.authKind === 'platform';
}

export function isTenantUserWithRole(user: AuthUser, roles: MembershipRole[]): boolean {
  return user.authKind === 'tenant' && roles.includes(user.role);
}
